import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';

import SessionStore from 'bundles/course-sessions/stores/SessionStore';
import ComputedModelStore from 'bundles/course-v2/stores/ComputedModelStore';
import CourseMembershipStore from 'bundles/in-course-stores/stores/CourseMembershipStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import CourseViewGradeStore from 'bundles/in-course-stores/stores/CourseViewGradeStore';
import ProgressStore from 'bundles/in-course-stores/stores/ProgressStore';
import S12nStore from 'bundles/in-course-stores/stores/S12nStore';
import VerificationStore from 'bundles/in-course-stores/stores/VerificationStore';

export const useCourseStoresLoading = () => {
  const { loading: courseLoading } = useFluxibleStore(CourseStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: courseMembershipLoading } = useFluxibleStore(CourseMembershipStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: computedModelsLoading } = useFluxibleStore(ComputedModelStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: s12nLoading } = useFluxibleStore(S12nStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: sessionLoading } = useFluxibleStore(SessionStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: courseViewGradeLoading } = useFluxibleStore(CourseViewGradeStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: progressLoading } = useFluxibleStore(ProgressStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: verificationDisplayLoading } = useFluxibleStore(VerificationStore, (store) => ({
    loading: !store.hasLoaded(),
  }));

  const loading: boolean =
    courseLoading ||
    courseMembershipLoading ||
    computedModelsLoading ||
    s12nLoading ||
    sessionLoading ||
    courseViewGradeLoading ||
    progressLoading ||
    verificationDisplayLoading;

  return { loading };
};
